<template>
  <section class="main__unities">
    <section class="header">
      <h4>{{ $t("descriptions.account_linked_units") }}</h4>
      <small>{{ $t("descriptions.select_unit_and_profile") }}</small>
    </section>

    <slot
      class="loading__contain"
      name="loading"
      v-if="!checkUnitiesProfiles"
    />

    <section class="unities" v-else>
      <section
        class="unity"
        v-for="(unity, index) in unitiesAndProfiles"
        :key="index"
        @click="changeSelectedUnity(unity)"
      >
        <section class="header">
          <section class="name">
            <v-icon v-if="unity.status" color="primary" size="16px">
              mdi-star-circle-outline
            </v-icon>

            <span> {{ unity.linked_unit.name }} </span>
          </section>

          <section class="icons">
            <v-icon
              v-if="unity.linked_unit.id === selectedUnity.id"
              color="primary"
              size="16px"
            >
              mdi-check-circle-outline
            </v-icon>

            <v-icon>
              {{
                unity.linked_unit.id === selectedUnity.id
                  ? "mdi-chevron-up"
                  : "mdi-chevron-down"
              }}
            </v-icon>
          </section>
        </section>

        <transition name="slide" mode="in-out">
          <section
            class="profiles"
            v-show="unity.linked_unit.id === selectedUnity.id"
          >
            <section
              v-for="(profile, index) in unity.user_unity_profiles"
              :key="index"
              @click="changeSelectedProfile(profile)"
              class="profile"
              :class="{
                'profile--disabled': unity.status && profile.status,
                'profile--active':
                  unity.linked_unit.id === selectedUnity.id &&
                  profile.id === selectedProfile.id,
              }"
            >
              <section class="name">
                <v-icon
                  v-if="unity.status && profile.status"
                  color="primary"
                  size="16px"
                >
                  mdi-star-circle-outline
                </v-icon>

                <span> {{ profile.name }} </span>
              </section>

              <v-icon v-if="profile.id === selectedProfile.id" dark size="16px">
                mdi-check-circle-outline
              </v-icon>
            </section>
          </section>
        </transition>
      </section>
    </section>

    <section class="buttons__actions__layout">
      <v-btn
        class="btn__default border__radius-10"
        type="submit"
        height="42"
        depressed
        @click="changeChangeUnityProfileStatus"
      >
        {{ $t("buttons.cancel") }}
      </v-btn>

      <v-btn
        class="btn__default border__radius-10"
        color="primary"
        type="submit"
        height="42"
        depressed
        :disabled="!checkSelectedData"
        @click="goToNextStep"
      >
        {{ $t("buttons.continue") }}
      </v-btn>
    </section>
  </section>
</template>

<script>
import { getConnectedUser } from "@/utils/localStorage";
import { getUserUnitiesAndProfiles } from "@/services/users";
import { mapActions } from "vuex";

export default {
  name: "ListUnitiesAndProfilesComponent",

  data: () => ({
    connectedUser: {},
    unitiesAndProfiles: [],
    selectedUnity: "",
    selectedProfile: "",
  }),

  computed: {
    checkUnitiesProfiles() {
      return this.unitiesAndProfiles.length;
    },

    checkSelectedData() {
      return this.selectedUnity !== "" && this.selectedProfile !== "";
    },
  },

  created() {
    this.connectedUser = getConnectedUser();
    this.setUnitiesAndProfiles();
  },

  methods: {
    ...mapActions(["changeChangeUnityProfileStatus"]),

    async setUnitiesAndProfiles() {
      const requestResponse = await getUserUnitiesAndProfiles(
        this.connectedUser.id
      );

      if (requestResponse.status) {
        const userUnityId = parseInt(this.connectedUser.unity_id);
        const userProfileId = parseInt(this.connectedUser.profile_id);

        this.unitiesAndProfiles = requestResponse.response.map((item) => {
          const isSelected = item.linked_unit.id === userUnityId;

          const updatedUserUnityProfiles = item.user_unity_profiles.map(
            (profile) => {
              const isProfileSelected =
                isSelected && profile.id === userProfileId;

              return {
                ...profile,
                status: isProfileSelected,
              };
            }
          );

          return {
            ...item,
            user_unity_profiles: updatedUserUnityProfiles,
            status: isSelected,
          };
        });
      } else {
        this.$snackbar.setParams(
          "error",
          this.$t("messages.error_not_defined"),
          requestResponse.response
        );
      }
    },

    changeSelectedUnity(unity) {
      if (this.selectedUnity.id !== unity.linked_unit.id) {
        this.selectedUnity = unity.linked_unit;
        this.selectedProfile = "";
      }
    },

    changeSelectedProfile(profile) {
      if (!profile.status) {
        this.selectedProfile = profile;
      }
    },

    goToNextStep() {
      this.$emit("setSelectedData", {
        unity: this.selectedUnity,
        profile: this.selectedProfile,
      });

      this.$emit("changeStep", 2);
    },
  },
};
</script>

<style lang="scss" scoped>
.main__unities {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;
  height: 100%;

  .unities {
    display: flex;
    flex-direction: column;
    gap: 5px;
    max-height: 320px;
    height: 320px;
    overflow: auto;
    padding: 5px;

    .unity {
      cursor: pointer;

      .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        background: #fafafa;
        padding: 10px;
        border-radius: 10px;
        transition: 0.4s;
        border: 1px solid transparent;

        &:hover {
          transition: 0.4s;
          border-color: #e9e9e9;
        }
        .name {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 13px;
          font-weight: 400;
        }

        .icons {
          display: flex;
          gap: 5px;
        }
      }

      .profiles {
        display: flex;
        flex-direction: column;
        gap: 8px;
        margin: 0 10px;
        padding: 10px 0 10px 10px;
        border-left: 1px solid #e9e9e9;

        .profile {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 10px;
          font-size: 12px;
          background: #fafafa;
          padding: 10px;
          border: 1px solid transparent;
          border-radius: 10px;
          transition: 0.4s;

          &:hover {
            transition: 0.4s;
            border-color: #e9e9e9;
          }

          .name {
            display: flex;
            align-items: center;
            gap: 10px;
          }

          &--active {
            border-color: #0984e9;
            background: #0984e9;
            color: #ffffff;

            &:hover {
              border-color: #0984e9;
            }
          }

          &--disabled {
            color: #d6d6d6;
            cursor: not-allowed;

            &:hover {
              border-color: transparent;
            }
          }
        }
      }
    }
  }
}

.slide-enter,
.slide-leave-to {
  // transform: translate(-50px);
  transform: translateY(-10px);
  opacity: 0;
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s;
}
</style>
